import React from 'react';
import { Box } from '@mui/material';
import { StyledContainer } from './styles';
import { get } from 'global/lib/lodash';
import useBodyOverflow from 'global/hooks/useBodyOverflow';
import InDoc from 'global/components/InDoc';

export const InteractiveDocument = (props) => {
  const { doc, document } = props;

  // Iframe owns scrolling; do not lock body (Document panel may still host chrome).
  useBodyOverflow({ hidden: false });

  const isIframe = get(doc, '0.document.assetsDir', document?.document?.assetsDir);

  const getLocalHtmlLink = () => {
    const { dir, html } = isIframe;
    return html;
  };

  return (
    <StyledContainer className={props.className}>
      {isIframe && (
        <Box sx={{ flex: 1, minHeight: 0, position: 'relative', width: '100%' }}>
          <InDoc url={getLocalHtmlLink()} />
        </Box>
      )}
    </StyledContainer>
  );
};

export default InteractiveDocument;
